import { useCallback, useMemo } from 'react';
import { useNavigate as useNavigateBase, useNavigationType, } from 'react-router-dom';
/**
 * React Router の useNavigate をラップしたカスタムフック
 */
export const useNavigate = () => {
    const navigate = useNavigateBase();
    const navigationType = useNavigationType();
    /**
     * 履歴に基づくページ遷移
     * @param to 移動する履歴の位置
     * @example navigate(-1) で 1つ前のページに遷移
     */
    const navigateTo = useCallback((to) => {
        navigate(to);
    }, [navigate]);
    /**
     * ページ遷移（history.push）
     * @param to リンク先
     * @param options.state location.state に保存されるデータ
     * @param options.preventScrollReset スクロール位置をリセットしない
     */
    const push = useCallback((to, options) => {
        navigate(to, options);
    }, [navigate]);
    /**
     * 履歴の変更（history.replace）
     * @param to リンク先
     * @param options.state location.state に保存されるデータ
     * @param options.preventScrollReset スクロール位置をリセットしない
     * @note replace 関数が呼び出されたとき、options.preventScrollReset はデフォルトで true に設定される
     */
    const replace = useCallback((to, options) => {
        navigate(to, Object.assign(Object.assign({ preventScrollReset: true }, options), { replace: true }));
    }, [navigate]);
    /**
     * useNavigate + useNavigationType
     * NOTE: useEffect 内で使用するため、Memo 化しています
     */
    const customNavigate = useMemo(() => ({
        action: navigationType,
        navigateTo,
        push,
        replace,
    }), [navigationType, push, replace, navigateTo]);
    return customNavigate;
};
